import React from "react";

export const Diagnosis02: React.FC = () => {
  return (
    <div className="diagnosis02-section">
      <div className="moreinfo-container">
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <div className="moreinfo-image-container">
              <img
                src="img/diagnosis2.png"
                className="moreinfo-image"
                alt="Exámenes de imagen"
              />
            </div>
          </div>
          
          <div className="moreinfo-right">
            <p className="moreinfo-text">
              <span className="diagnosis02-bullet">• <span className="diagnosis02-highlight-pink">EXÁMENES DE IMAGEN</span></span>
            </p>
            
            <p className="moreinfo-text">
              Una vez que hayas pasado la primera consulta con el médico y ante la sospecha de una posible endometriosis, 
              el siguiente paso es indicarte estudios de imágenes que ayuden a ver, si es posible, lesiones.
            </p>
            
            <p className="moreinfo-text">
              • La <span className="moreinfo-highlight-blue diagnosis02-underline">ecografía transvaginal especializada</span> es un tipo de estudio que 
              se debe realizar por alguien entrenado en buscar lesiones de endometriosis. A diferencia de una ecografía transvaginal normal, 
              en este estudio se suele demorar unos 15-20 minutos y la exploración es súper detallada porque se va a intentar visualizar 
              lesiones o nódulos. Además el médico va a fijarse si existen signos de adherencias mirando si tus órganos tienen movilidad o 
              parecen estar "pegados".
            </p>
            
            <p className="moreinfo-text">
              • La <span className="moreinfo-highlight-blue diagnosis02-underline">resonancia magnética </span>es otro estudio que puede pedir tu 
              médico. En este se sacan imágenes de toda tu pelvis y eventualmente abdomen y con el contraste por vía venosa se buscan lesiones 
              sugestivas de endometriosis. También es necesario que las imágenes las vea alguien especializado o de lo contrario pueden no saber 
              interpretar lo que están viendo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};